/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    baseUrl = 'http://localhost:8206';
    securityData = null;
    securityWorker;
    abortControllers = new Map();
    customFetch = (...fetchParams) => fetch(...fetchParams);
    baseApiParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    };
    constructor(apiConfig = {}) {
        Object.assign(this, apiConfig);
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v) => this.encodeQueryParam(key, v)).join('&');
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
        return keys
            .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
            .join('&');
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }
    contentFormatters = {
        [ContentType.Json]: (input) => input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
        [ContentType.Text]: (input) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
        [ContentType.FormData]: (input) => Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData()),
        [ContentType.UrlEncoded]: (input) => this.toQueryString(input),
    };
    mergeRequestParams(params1, params2) {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    createAbortSignal = (cancelToken) => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }
        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };
    abortRequest = (cancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);
        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };
    request = async ({ body, secure, path, type, query, format, baseUrl, cancelToken, ...params }) => {
        const secureParams = ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter = this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;
        return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
            },
            signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
            body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response.clone();
            r.data = null;
            r.error = null;
            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                    .then((data) => {
                    if (r.ok) {
                        r.data = data;
                    }
                    else {
                        r.error = data;
                    }
                    return r;
                })
                    .catch((e) => {
                    r.error = e;
                    return r;
                });
            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }
            if (!response.ok)
                throw data;
            return data;
        });
    };
}
/**
 * @title Blade Trade API
 * @version 1.0.0
 * @baseUrl http://localhost:8206
 */
export class TradeApiClient extends HttpClient {
    metrics = {
        /**
         * No description
         *
         * @name MetricsList
         * @request GET:/metrics
         * @secure
         */
        metricsList: (params = {}) => this.request({
            path: `/metrics`,
            method: 'GET',
            secure: true,
            ...params,
        }),
    };
    health = {
        /**
         * No description
         *
         * @name HealthList
         * @request GET:/health
         * @secure
         */
        healthList: (params = {}) => this.request({
            path: `/health`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    account = {
        /**
         * @description Addresses a Basic user deposits to, created on demand
         *
         * @tags Account
         * @name AccountDepositAddressesDetail
         * @request GET:/api/account/{tgId}/deposit-addresses
         * @secure
         */
        accountDepositAddressesDetail: (tgId, params = {}) => this.request({
            path: `/api/account/${tgId}/deposit-addresses`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description How this person trades
         *
         * @tags Account
         * @name AccountTradingModeDetail
         * @request GET:/api/account/{tgId}/trading-mode
         * @secure
         */
        accountTradingModeDetail: (tgId, params = {}) => this.request({
            path: `/api/account/${tgId}/trading-mode`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Switch between the simple and the self-custody mode
         *
         * @tags Account
         * @name AccountTradingModeCreate
         * @request POST:/api/account/{tgId}/trading-mode
         * @secure
         */
        accountTradingModeCreate: (tgId, data, params = {}) => this.request({
            path: `/api/account/${tgId}/trading-mode`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description What a Basic user can spend right now
         *
         * @tags Account
         * @name AccountBalanceDetail
         * @request GET:/api/account/{tgId}/balance
         * @secure
         */
        accountBalanceDetail: (tgId, params = {}) => this.request({
            path: `/api/account/${tgId}/balance`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Buy a token out of the Basic balance
         *
         * @tags Account
         * @name AccountBuyCreate
         * @request POST:/api/account/{tgId}/buy
         * @secure
         */
        accountBuyCreate: (tgId, data, params = {}) => this.request({
            path: `/api/account/${tgId}/buy`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description What selling a share of a position would return, without selling
         *
         * @tags Account
         * @name AccountSellQuoteCreate
         * @request POST:/api/account/{tgId}/sell/quote
         * @secure
         */
        accountSellQuoteCreate: (tgId, data, params = {}) => this.request({
            path: `/api/account/${tgId}/sell/quote`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Sell a share of a Basic position back into the balance
         *
         * @tags Account
         * @name AccountSellCreate
         * @request POST:/api/account/{tgId}/sell
         * @secure
         */
        accountSellCreate: (tgId, data, params = {}) => this.request({
            path: `/api/account/${tgId}/sell`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Send the Basic balance out, to any supported chain
         *
         * @tags Account
         * @name AccountWithdrawCreate
         * @request POST:/api/account/{tgId}/withdraw
         * @secure
         */
        accountWithdrawCreate: (tgId, data, params = {}) => this.request({
            path: `/api/account/${tgId}/withdraw`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description What this person has bought and withdrawn, newest first
         *
         * @tags Account
         * @name AccountOrdersDetail
         * @request GET:/api/account/{tgId}/orders
         * @secure
         */
        accountOrdersDetail: ({ tgId, ...query }, params = {}) => this.request({
            path: `/api/account/${tgId}/orders`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description What a Basic user holds, valued at the last fetched prices
         *
         * @tags Account
         * @name AccountPositionsDetail
         * @request GET:/api/account/{tgId}/positions
         * @secure
         */
        accountPositionsDetail: (tgId, params = {}) => this.request({
            path: `/api/account/${tgId}/positions`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Somebody’s own calls, newest first, and what each did since
         *
         * @tags Account
         * @name AccountCallsDetail
         * @request GET:/api/account/{tgId}/calls
         * @secure
         */
        accountCallsDetail: ({ tgId, ...query }, params = {}) => this.request({
            path: `/api/account/${tgId}/calls`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Where an order got to
         *
         * @tags Account
         * @name AccountOrdersDetail2
         * @request GET:/api/account/{tgId}/orders/{orderId}
         * @originalName accountOrdersDetail
         * @duplicate
         * @secure
         */
        accountOrdersDetail2: (tgId, orderId, params = {}) => this.request({
            path: `/api/account/${tgId}/orders/${orderId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    admin = {
        /**
         * @description What this person may do, if anything
         *
         * @tags Admin
         * @name AdminDetail
         * @request GET:/api/admin/{tgId}
         * @secure
         */
        adminDetail: (tgId, params = {}) => this.request({
            path: `/api/admin/${tgId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Users, orders, revenue, the queue and the fee wallet
         *
         * @tags Admin
         * @name AdminOverviewDetail
         * @request GET:/api/admin/{tgId}/overview
         * @secure
         */
        adminOverviewDetail: (tgId, params = {}) => this.request({
            path: `/api/admin/${tgId}/overview`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Everybody who works on the service
         *
         * @tags Admin
         * @name AdminStaffDetail
         * @request GET:/api/admin/{tgId}/staff
         * @secure
         */
        adminStaffDetail: (tgId, params = {}) => this.request({
            path: `/api/admin/${tgId}/staff`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Give somebody a role, or change the one they have
         *
         * @tags Admin
         * @name AdminStaffCreate
         * @request POST:/api/admin/{tgId}/staff
         * @secure
         */
        adminStaffCreate: (tgId, data, params = {}) => this.request({
            path: `/api/admin/${tgId}/staff`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Take a role away again
         *
         * @tags Admin
         * @name AdminStaffDelete
         * @request DELETE:/api/admin/{tgId}/staff/{revokeFrom}
         * @secure
         */
        adminStaffDelete: (tgId, revokeFrom, params = {}) => this.request({
            path: `/api/admin/${tgId}/staff/${revokeFrom}`,
            method: 'DELETE',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description How many wait for the terminal, and how many are in
         *
         * @tags Admin
         * @name AdminTerminalAccessDetail
         * @request GET:/api/admin/{tgId}/terminal-access
         * @secure
         */
        adminTerminalAccessDetail: (tgId, params = {}) => this.request({
            path: `/api/admin/${tgId}/terminal-access`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Let people into the terminal; the bot tells each of them after
         *
         * @tags Admin
         * @name AdminTerminalAccessCreate
         * @request POST:/api/admin/{tgId}/terminal-access
         * @secure
         */
        adminTerminalAccessCreate: (tgId, data, params = {}) => this.request({
            path: `/api/admin/${tgId}/terminal-access`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
    };
    waitlist = {
        /**
         * @description Take a place in the queue, or keep the one you have
         *
         * @tags Waitlist
         * @name WaitlistCreate
         * @request POST:/api/waitlist/
         * @secure
         */
        waitlistCreate: (data, params = {}) => this.request({
            path: `/api/waitlist/`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Where somebody stands, and how many they brought
         *
         * @tags Waitlist
         * @name WaitlistDetail
         * @request GET:/api/waitlist/{provider}/{providerId}
         * @secure
         */
        waitlistDetail: (provider, providerId, params = {}) => this.request({
            path: `/api/waitlist/${provider}/${providerId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    user = {
        /**
         * @description People worth following that this one does not yet
         *
         * @tags User
         * @name ActivityRecommendationsList
         * @request GET:/api/activity/{delugeId}/recommendations
         * @secure
         */
        activityRecommendationsList: ({ delugeId, ...query }, params = {}) => this.request({
            path: `/api/activity/${delugeId}/recommendations`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Who follows this person, or who they follow
         *
         * @tags User
         * @name ActivityFollowersDetail
         * @request GET:/api/activity/{delugeId}/followers/{followersType}
         * @secure
         */
        activityFollowersDetail: ({ delugeId, followersType, ...query }, params = {}) => this.request({
            path: `/api/activity/${delugeId}/followers/${followersType}`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Follow or unfollow a user
         *
         * @tags User
         * @name ActivityActionCreate
         * @request POST:/api/activity/{delugeId}/action/{targetDelugeId}/{actionType}
         * @secure
         */
        activityActionCreate: (delugeId, targetDelugeId, actionType, params = {}) => this.request({
            path: `/api/activity/${delugeId}/action/${targetDelugeId}/${actionType}`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Registers user in the system and creates wallets.
         *
         * @tags User
         * @name UserRegisterCreate
         * @request POST:/api/user/register
         * @secure
         */
        userRegisterCreate: (data, params = {}) => this.request({
            path: `/api/user/register`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags User
         * @name UserDetail
         * @request GET:/api/user/{tgId}
         * @secure
         */
        userDetail: (tgId, params = {}) => this.request({
            path: `/api/user/${tgId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags User
         * @name UserSwapSettingsUpdate
         * @request PUT:/api/user/swap-settings
         * @secure
         */
        userSwapSettingsUpdate: (data, params = {}) => this.request({
            path: `/api/user/swap-settings`,
            method: 'PUT',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags User
         * @name UserBuyButtonsUpdate
         * @request PUT:/api/user/buy-buttons
         * @secure
         */
        userBuyButtonsUpdate: (data, params = {}) => this.request({
            path: `/api/user/buy-buttons`,
            method: 'PUT',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags User
         * @name UserQuickBuySettingsUpdate
         * @request PUT:/api/user/quick-buy-settings
         * @secure
         */
        userQuickBuySettingsUpdate: (data, params = {}) => this.request({
            path: `/api/user/quick-buy-settings`,
            method: 'PUT',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Signs in with a password, Google, Telegram or X; a password is optional for the social ones
         *
         * @tags User
         * @name UserLoginCreate
         * @request POST:/api/user/login
         * @secure
         */
        userLoginCreate: (data, params = {}) => this.request({
            path: `/api/user/login`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Renews the sign-in from its refresh cookie
         *
         * @tags User
         * @name UserRefreshCreate
         * @request POST:/api/user/refresh
         * @secure
         */
        userRefreshCreate: (params = {}) => this.request({
            path: `/api/user/refresh`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Signs out, here and in CAS
         *
         * @tags User
         * @name UserLogoutCreate
         * @request POST:/api/user/logout
         * @secure
         */
        userLogoutCreate: (params = {}) => this.request({
            path: `/api/user/logout`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description The signed-in user's account
         *
         * @tags User
         * @name UserMeList
         * @request GET:/api/user/me
         * @secure
         */
        userMeList: (params = {}) => this.request({
            path: `/api/user/me`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags User
         * @name UserCheckUsernameList
         * @request GET:/api/user/check-username
         * @secure
         */
        userCheckUsernameList: (query, params = {}) => this.request({
            path: `/api/user/check-username`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A token to sign in through the Telegram bot with
         *
         * @tags User
         * @name UserTgTokenCreate
         * @request POST:/api/user/tg/token
         * @secure
         */
        userTgTokenCreate: (params = {}) => this.request({
            path: `/api/user/tg/token`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Ends every session but this one
         *
         * @tags User
         * @name UserSessionClearCreate
         * @request POST:/api/user/session/clear
         * @secure
         */
        userSessionClearCreate: (params = {}) => this.request({
            path: `/api/user/session/clear`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Changes the password; other sessions end
         *
         * @tags User
         * @name UserChangePasswordCreate
         * @request POST:/api/user/change-password
         * @secure
         */
        userChangePasswordCreate: (data, params = {}) => this.request({
            path: `/api/user/change-password`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Ends the sessions of one address
         *
         * @tags User
         * @name UserSessionDelete
         * @request DELETE:/api/user/session
         * @secure
         */
        userSessionDelete: (data, params = {}) => this.request({
            path: `/api/user/session`,
            method: 'DELETE',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Signs up with a Telegram sign-in code and a password
         *
         * @tags User
         * @name UserRegisterTgCreate
         * @request POST:/api/user/register/tg
         * @secure
         */
        userRegisterTgCreate: (data, params = {}) => this.request({
            path: `/api/user/register/tg`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Signs up with a Google sign-in code and a password
         *
         * @tags User
         * @name UserRegisterGoogleCreate
         * @request POST:/api/user/register/google
         * @secure
         */
        userRegisterGoogleCreate: (data, params = {}) => this.request({
            path: `/api/user/register/google`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Signs up with an X sign-in code and a password
         *
         * @tags User
         * @name UserRegisterTwitterCreate
         * @request POST:/api/user/register/twitter
         * @secure
         */
        userRegisterTwitterCreate: (data, params = {}) => this.request({
            path: `/api/user/register/twitter`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Whether a Google identity already has an account
         *
         * @tags User
         * @name UserIsExistsGoogleList
         * @request GET:/api/user/is-exists/google
         * @secure
         */
        userIsExistsGoogleList: (query, params = {}) => this.request({
            path: `/api/user/is-exists/google`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Whether an X identity already has an account
         *
         * @tags User
         * @name UserIsExistsTwitterList
         * @request GET:/api/user/is-exists/twitter
         * @secure
         */
        userIsExistsTwitterList: (query, params = {}) => this.request({
            path: `/api/user/is-exists/twitter`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Signs up with a username and password (not in production)
         *
         * @tags User
         * @name UserRegisterDevCreate
         * @request POST:/api/user/register/dev
         * @secure
         */
        userRegisterDevCreate: (data, params = {}) => this.request({
            path: `/api/user/register/dev`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Tokens the user hid from the explore feeds
         *
         * @tags User
         * @name UserHiddenTokensList
         * @request GET:/api/user/hidden-tokens
         * @secure
         */
        userHiddenTokensList: (query, params = {}) => this.request({
            path: `/api/user/hidden-tokens`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Hides a token from the explore feeds
         *
         * @tags User
         * @name UserHiddenTokensCreate
         * @request POST:/api/user/hidden-tokens
         * @secure
         */
        userHiddenTokensCreate: (data, params = {}) => this.request({
            path: `/api/user/hidden-tokens`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description Shows a hidden token again
         *
         * @tags User
         * @name UserHiddenTokensDelete
         * @request DELETE:/api/user/hidden-tokens
         * @secure
         */
        userHiddenTokensDelete: (data, params = {}) => this.request({
            path: `/api/user/hidden-tokens`,
            method: 'DELETE',
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description Stars a pair, or unstars it
         *
         * @tags User
         * @name UserToggleFavouritePairCreate
         * @request POST:/api/user/toggle-favourite-pair
         * @secure
         */
        userToggleFavouritePairCreate: (data, params = {}) => this.request({
            path: `/api/user/toggle-favourite-pair`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description The starred pairs, without their cards
         *
         * @tags User
         * @name UserFavouritePairsMetaCreate
         * @request POST:/api/user/favourite-pairs-meta
         * @secure
         */
        userFavouritePairsMetaCreate: (data, params = {}) => this.request({
            path: `/api/user/favourite-pairs-meta`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Reorders the starred pairs
         *
         * @tags User
         * @name UserSetFavouritePairsOrderCreate
         * @request POST:/api/user/set-favourite-pairs-order
         * @secure
         */
        userSetFavouritePairsOrderCreate: (data, params = {}) => this.request({
            path: `/api/user/set-favourite-pairs-order`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description The starred pairs as cards
         *
         * @tags User
         * @name UserFavouritePairsCreate
         * @request POST:/api/user/favourite-pairs
         * @secure
         */
        userFavouritePairsCreate: (data, params = {}) => this.request({
            path: `/api/user/favourite-pairs`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Pairs recently opened from search, newest first
         *
         * @tags User
         * @name UserRecentTradeSearchesList
         * @request GET:/api/user/recent-trade-searches
         * @secure
         */
        userRecentTradeSearchesList: (query, params = {}) => this.request({
            path: `/api/user/recent-trade-searches`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Records a pair opened from search
         *
         * @tags User
         * @name UserAddTradeSearchCreate
         * @request POST:/api/user/add-trade-search
         * @secure
         */
        userAddTradeSearchCreate: (data, params = {}) => this.request({
            path: `/api/user/add-trade-search`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Removes a pair from the recent searches
         *
         * @tags User
         * @name UserDeleteTradeSearchCreate
         * @request POST:/api/user/delete-trade-search
         * @secure
         */
        userDeleteTradeSearchCreate: (data, params = {}) => this.request({
            path: `/api/user/delete-trade-search`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description New amounts for the quick buy and sell buttons
         *
         * @tags User
         * @name UserEditInstantTradeButtonsCreate
         * @request POST:/api/user/edit-instant-trade-buttons
         * @secure
         */
        userEditInstantTradeButtonsCreate: (data, params = {}) => this.request({
            path: `/api/user/edit-instant-trade-buttons`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Incognito here; quick login with a one-time code in CAS
         *
         * @tags User
         * @name UserSettingsPartialUpdate
         * @request PATCH:/api/user/settings
         * @secure
         */
        userSettingsPartialUpdate: (data, params = {}) => this.request({
            path: `/api/user/settings`,
            method: 'PATCH',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description The names the terminal shows for the user
         *
         * @tags User
         * @name UserProfilePartialUpdate
         * @request PATCH:/api/user/profile
         * @secure
         */
        userProfilePartialUpdate: (data, params = {}) => this.request({
            path: `/api/user/profile`,
            method: 'PATCH',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description The chain the terminal opens on
         *
         * @tags User
         * @name UserChangeNetworkCreate
         * @request POST:/api/user/change-network
         * @secure
         */
        userChangeNetworkCreate: (data, params = {}) => this.request({
            path: `/api/user/change-network`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
    };
    comment = {
        /**
         * @description The thread under a pair
         *
         * @tags Comment
         * @name ActivityCommentsList
         * @request GET:/api/activity/{pairAddress}/comments
         * @secure
         */
        activityCommentsList: ({ pairAddress, ...query }, params = {}) => this.request({
            path: `/api/activity/${pairAddress}/comments`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Post about a pair, or reply to a post
         *
         * @tags Comment
         * @name ActivityCommentCreateCreate
         * @request POST:/api/activity/{pairAddress}/comment/create
         * @secure
         */
        activityCommentCreateCreate: (pairAddress, data, params = {}) => this.request({
            path: `/api/activity/${pairAddress}/comment/create`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Change what you wrote
         *
         * @tags Comment
         * @name ActivityCommentEditCreate
         * @request POST:/api/activity/comment/edit
         * @secure
         */
        activityCommentEditCreate: (data, params = {}) => this.request({
            path: `/api/activity/comment/edit`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Take back what you wrote
         *
         * @tags Comment
         * @name ActivityCommentDeleteCreate
         * @request POST:/api/activity/{pairAddress}/comment/delete
         * @secure
         */
        activityCommentDeleteCreate: (pairAddress, data, params = {}) => this.request({
            path: `/api/activity/${pairAddress}/comment/delete`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Like or dislike a comment, or take it back
         *
         * @tags Comment
         * @name ActivityCommentToggleReactionCreate
         * @request POST:/api/activity/{pairAddress}/comment/{commentId}/toggle-reaction
         * @secure
         */
        activityCommentToggleReactionCreate: (pairAddress, commentId, data, params = {}) => this.request({
            path: `/api/activity/${pairAddress}/comment/${commentId}/toggle-reaction`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Somebody’s own posts, with the pair each one is about
         *
         * @tags Comment
         * @name ActivityUserCommentsList
         * @request GET:/api/activity/user/{delugeId}/comments
         * @secure
         */
        activityUserCommentsList: ({ delugeId, ...query }, params = {}) => this.request({
            path: `/api/activity/user/${delugeId}/comments`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    trade = {
        /**
         * @description Leave an order waiting for a price
         *
         * @tags Trade
         * @name TradeOrderCreate
         * @request POST:/api/trade/orders
         * @secure
         */
        tradeOrderCreate: (data, params = {}) => this.request({
            path: `/api/trade/orders`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description The orders this account has left waiting
         *
         * @tags Trade
         * @name TradeOrdersList
         * @request GET:/api/trade/orders
         * @secure
         */
        tradeOrdersList: (query, params = {}) => this.request({
            path: `/api/trade/orders`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description The tokens this account has orders waiting on
         *
         * @tags Trade
         * @name TradeOrderTokensList
         * @request GET:/api/trade/orders/tokens
         * @secure
         */
        tradeOrderTokensList: (query, params = {}) => this.request({
            path: `/api/trade/orders/tokens`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Take one order back
         *
         * @tags Trade
         * @name TradeOrderCancel
         * @request POST:/api/trade/orders/{orderId}/cancel
         * @secure
         */
        tradeOrderCancel: (orderId, params = {}) => this.request({
            path: `/api/trade/orders/${orderId}/cancel`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Take back everything still waiting
         *
         * @tags Trade
         * @name TradeOrdersCancelAll
         * @request POST:/api/trade/orders/cancel-all
         * @secure
         */
        tradeOrdersCancelAll: (data, params = {}) => this.request({
            path: `/api/trade/orders/cancel-all`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description This endpoint allows users to place a limit order for trading.
         *
         * @tags Trade
         * @name TradeLimitOrderCreate
         * @request POST:/api/trade/limit-order
         * @secure
         */
        tradeLimitOrderCreate: (data, params = {}) => this.request({
            path: `/api/trade/limit-order`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description This endpoint allows users to place a limit order for trading.
         *
         * @tags Trade
         * @name TradeLimitOrderEditCreate
         * @request POST:/api/trade/limit-order/edit
         * @secure
         */
        tradeLimitOrderEditCreate: (data, params = {}) => this.request({
            path: `/api/trade/limit-order/edit`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description This endpoint allows users to get their limit orders.
         *
         * @tags Trade
         * @name TradeLimitOrdersList
         * @request GET:/api/trade/limit-orders
         * @secure
         */
        tradeLimitOrdersList: (query, params = {}) => this.request({
            path: `/api/trade/limit-orders`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description This endpoint allows users to cancel their limit order.
         *
         * @tags Trade
         * @name TradeCancelLimitOrderCreate
         * @request POST:/api/trade/cancel-limit-order
         * @secure
         */
        tradeCancelLimitOrderCreate: (data, params = {}) => this.request({
            path: `/api/trade/cancel-limit-order`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description This endpoint allows to user to get trade settings.
         *
         * @tags Trade
         * @name TradeRecentTradesList
         * @request GET:/api/trade/recent-trades
         * @secure
         */
        tradeRecentTradesList: (query, params = {}) => this.request({
            path: `/api/trade/recent-trades`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description The user's trade presets on every chain
         *
         * @tags Trade
         * @name TradeSettingsList
         * @request GET:/api/trade/settings
         * @secure
         */
        tradeSettingsList: (params = {}) => this.request({
            path: `/api/trade/settings`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description The user's trade presets on one chain
         *
         * @tags Trade
         * @name TradeSettingsByNetworkList
         * @request GET:/api/trade/settings-by-network
         * @secure
         */
        tradeSettingsByNetworkList: (query, params = {}) => this.request({
            path: `/api/trade/settings-by-network`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Picks the preset a chain trades with
         *
         * @tags Trade
         * @name TradeSettingsActivePresetUpdate
         * @request PUT:/api/trade/settings/active-preset
         * @secure
         */
        tradeSettingsActivePresetUpdate: (data, params = {}) => this.request({
            path: `/api/trade/settings/active-preset`,
            method: 'PUT',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Changes a preset's name, emoji and settings
         *
         * @tags Trade
         * @name TradeSettingsPresetUpdate
         * @request PUT:/api/trade/settings/preset
         * @secure
         */
        tradeSettingsPresetUpdate: (data, params = {}) => this.request({
            path: `/api/trade/settings/preset`,
            method: 'PUT',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Sets a preset zone's buy or sell amount
         *
         * @tags Trade
         * @name TradeSettingsPresetAmountUpdate
         * @request PUT:/api/trade/settings/preset/amount
         * @secure
         */
        tradeSettingsPresetAmountUpdate: (data, params = {}) => this.request({
            path: `/api/trade/settings/preset/amount`,
            method: 'PUT',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Sets a screen's quick buy or sell amount
         *
         * @tags Trade
         * @name TradeSettingsQuickAmountUpdate
         * @request PUT:/api/trade/settings/quick-amount
         * @secure
         */
        tradeSettingsQuickAmountUpdate: (data, params = {}) => this.request({
            path: `/api/trade/settings/quick-amount`,
            method: 'PUT',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
    };
    otp = {
        /**
         * @description A new one-time-code secret, to show as a QR code
         *
         * @tags OTP
         * @name UserOtpList
         * @request GET:/api/user/otp
         * @secure
         */
        userOtpList: (params = {}) => this.request({
            path: `/api/user/otp`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Turns one-time codes on with a first valid code
         *
         * @tags OTP
         * @name UserOtpCreate
         * @request POST:/api/user/otp
         * @secure
         */
        userOtpCreate: (data, params = {}) => this.request({
            path: `/api/user/otp`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Turns one-time codes off, with a valid code
         *
         * @tags OTP
         * @name UserOtpDelete
         * @request DELETE:/api/user/otp
         * @secure
         */
        userOtpDelete: (data, params = {}) => this.request({
            path: `/api/user/otp`,
            method: 'DELETE',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Checks a one-time code for this session
         *
         * @tags OTP
         * @name UserOtpVerifyCreate
         * @request POST:/api/user/otp/verify
         * @secure
         */
        userOtpVerifyCreate: (data, params = {}) => this.request({
            path: `/api/user/otp/verify`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
    };
    support = {
        /**
         * @description A single-use ticket that signs the trade socket in
         *
         * @tags Support
         * @name SupportWsTicketCreate
         * @request POST:/api/support/ws-ticket
         * @secure
         */
        supportWsTicketCreate: (params = {}) => this.request({
            path: `/api/support/ws-ticket`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Opens a ticket with its first message
         *
         * @tags Support
         * @name SupportTicketsCreate
         * @request POST:/api/support/tickets
         * @secure
         */
        supportTicketsCreate: (data, params = {}) => this.request({
            path: `/api/support/tickets`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description The user's tickets, most recently active first
         *
         * @tags Support
         * @name SupportTicketsList
         * @request GET:/api/support/tickets
         * @secure
         */
        supportTicketsList: (query, params = {}) => this.request({
            path: `/api/support/tickets`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Unread The user's tickets and messages
         *
         * @tags Support
         * @name SupportTicketsUnreadList
         * @request GET:/api/support/tickets/unread
         * @secure
         */
        supportTicketsUnreadList: (params = {}) => this.request({
            path: `/api/support/tickets/unread`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A ticket, marked read
         *
         * @tags Support
         * @name SupportTicketsDetail
         * @request GET:/api/support/tickets/{ticketId}
         * @secure
         */
        supportTicketsDetail: (ticketId, params = {}) => this.request({
            path: `/api/support/tickets/${ticketId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A page of a ticket's messages; marks it read
         *
         * @tags Support
         * @name SupportTicketsMessagesDetail
         * @request GET:/api/support/tickets/{ticketId}/messages
         * @secure
         */
        supportTicketsMessagesDetail: ({ ticketId, ...query }, params = {}) => this.request({
            path: `/api/support/tickets/${ticketId}/messages`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Writes in a ticket, reopening it if closed
         *
         * @tags Support
         * @name SupportTicketsMessagesCreate
         * @request POST:/api/support/tickets/{ticketId}/messages
         * @secure
         */
        supportTicketsMessagesCreate: (ticketId, data, params = {}) => this.request({
            path: `/api/support/tickets/${ticketId}/messages`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Closes or reopens a ticket
         *
         * @tags Support
         * @name SupportTicketsStatusPartialUpdate
         * @request PATCH:/api/support/tickets/{ticketId}/status
         * @secure
         */
        supportTicketsStatusPartialUpdate: (ticketId, data, params = {}) => this.request({
            path: `/api/support/tickets/${ticketId}/status`,
            method: 'PATCH',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Unread All tickets and messages
         *
         * @tags Support
         * @name SupportAdminTicketsUnreadList
         * @request GET:/api/support/admin/tickets/unread
         * @secure
         */
        supportAdminTicketsUnreadList: (params = {}) => this.request({
            path: `/api/support/admin/tickets/unread`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description All tickets, most recently active first
         *
         * @tags Support
         * @name SupportAdminTicketsList
         * @request GET:/api/support/admin/tickets
         * @secure
         */
        supportAdminTicketsList: (query, params = {}) => this.request({
            path: `/api/support/admin/tickets`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A ticket, marked read
         *
         * @tags Support
         * @name SupportAdminTicketsDetail
         * @request GET:/api/support/admin/tickets/{ticketId}
         * @secure
         */
        supportAdminTicketsDetail: (ticketId, params = {}) => this.request({
            path: `/api/support/admin/tickets/${ticketId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A page of a ticket's messages; marks it read
         *
         * @tags Support
         * @name SupportAdminTicketsMessagesDetail
         * @request GET:/api/support/admin/tickets/{ticketId}/messages
         * @secure
         */
        supportAdminTicketsMessagesDetail: ({ ticketId, ...query }, params = {}) => this.request({
            path: `/api/support/admin/tickets/${ticketId}/messages`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Writes in a ticket, reopening it if closed
         *
         * @tags Support
         * @name SupportAdminTicketsMessagesCreate
         * @request POST:/api/support/admin/tickets/{ticketId}/messages
         * @secure
         */
        supportAdminTicketsMessagesCreate: (ticketId, data, params = {}) => this.request({
            path: `/api/support/admin/tickets/${ticketId}/messages`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Closes or reopens a ticket
         *
         * @tags Support
         * @name SupportAdminTicketsStatusPartialUpdate
         * @request PATCH:/api/support/admin/tickets/{ticketId}/status
         * @secure
         */
        supportAdminTicketsStatusPartialUpdate: (ticketId, data, params = {}) => this.request({
            path: `/api/support/admin/tickets/${ticketId}/status`,
            method: 'PATCH',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
    };
    telegram = {
        /**
         * @description For the bot: the code a Telegram user takes back to the terminal
         *
         * @tags Telegram
         * @name TelegramCodeCreate
         * @request POST:/api/telegram/code
         * @secure
         */
        telegramCodeCreate: (data, params = {}) => this.request({
            path: `/api/telegram/code`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Links a Telegram account, from its sign-in code
         *
         * @tags Telegram
         * @name TelegramAssignCreate
         * @request POST:/api/telegram/assign
         * @secure
         */
        telegramAssignCreate: (data, params = {}) => this.request({
            path: `/api/telegram/assign`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Unlinks the Telegram account
         *
         * @tags Telegram
         * @name TelegramUnassignCreate
         * @request POST:/api/telegram/unassign
         * @secure
         */
        telegramUnassignCreate: (params = {}) => this.request({
            path: `/api/telegram/unassign`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    twitter = {
        /**
         * @description Where to send the user to sign in with X
         *
         * @tags Twitter
         * @name TwitterRedirectCreate
         * @request POST:/api/twitter/redirect
         * @secure
         */
        twitterRedirectCreate: (data, params = {}) => this.request({
            path: `/api/twitter/redirect`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Links an X account, from its sign-in code
         *
         * @tags Twitter
         * @name TwitterAssignCreate
         * @request POST:/api/twitter/assign
         * @secure
         */
        twitterAssignCreate: (data, params = {}) => this.request({
            path: `/api/twitter/assign`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Unlinks the X account
         *
         * @tags Twitter
         * @name TwitterUnassignCreate
         * @request POST:/api/twitter/unassign
         * @secure
         */
        twitterUnassignCreate: (params = {}) => this.request({
            path: `/api/twitter/unassign`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    google = {
        /**
         * @description Links a Google account, from its sign-in code
         *
         * @tags Google
         * @name GoogleAssignCreate
         * @request POST:/api/google/assign
         * @secure
         */
        googleAssignCreate: (data, params = {}) => this.request({
            path: `/api/google/assign`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Unlinks the Google account
         *
         * @tags Google
         * @name GoogleUnassignCreate
         * @request POST:/api/google/unassign
         * @secure
         */
        googleUnassignCreate: (params = {}) => this.request({
            path: `/api/google/unassign`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    wallet = {
        /**
         * No description
         *
         * @tags Wallet
         * @name WalletDetail
         * @request GET:/api/wallet/{tgId}
         * @secure
         */
        walletDetail: (tgId, params = {}) => this.request({
            path: `/api/wallet/${tgId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Wallet
         * @name WalletGenerateCreate
         * @request POST:/api/wallet/generate
         * @secure
         */
        walletGenerateCreate: (data, params = {}) => this.request({
            path: `/api/wallet/generate`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Add one more wallet to somebody who already has some
         *
         * @tags Wallet
         * @name WalletCreateCreate
         * @request POST:/api/wallet/create
         * @secure
         */
        walletCreateCreate: (data, params = {}) => this.request({
            path: `/api/wallet/create`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Rename a wallet, change its emoji, or make it default
         *
         * @tags Wallet
         * @name WalletEditCreate
         * @request POST:/api/wallet/edit
         * @secure
         */
        walletEditCreate: (data, params = {}) => this.request({
            path: `/api/wallet/edit`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description This endpoint allows to user export public key and private key.
         *
         * @tags Wallet
         * @name WalletExportCreate
         * @request POST:/api/wallet/export
         * @secure
         */
        walletExportCreate: (data, params = {}) => this.request({
            path: `/api/wallet/export`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description This endpoint allows to user import wallet with private key.
         *
         * @tags Wallet
         * @name WalletImportCreate
         * @request POST:/api/wallet/import
         * @secure
         */
        walletImportCreate: (data, params = {}) => this.request({
            path: `/api/wallet/import`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Wallet
         * @name WalletTransferCreate
         * @request POST:/api/wallet/transfer
         * @secure
         */
        walletTransferCreate: (data, params = {}) => this.request({
            path: `/api/wallet/transfer`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Wallet
         * @name WalletUpdateStatusUpdate
         * @request PUT:/api/wallet/update-status
         * @secure
         */
        walletUpdateStatusUpdate: (data, params = {}) => this.request({
            path: `/api/wallet/update-status`,
            method: 'PUT',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Adds a wallet whose keys are on the device
         *
         * @tags Wallet
         * @name WalletStoreWalletCreate
         * @request POST:/api/wallet/store-wallet
         * @secure
         */
        walletStoreWalletCreate: (data, params = {}) => this.request({
            path: `/api/wallet/store-wallet`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Makes a wallet here, with its key kept by the signer
         *
         * @tags Wallet
         * @name WalletCreateWalletCreate
         * @request POST:/api/wallet/create-wallet
         * @secure
         */
        walletCreateWalletCreate: (data, params = {}) => this.request({
            path: `/api/wallet/create-wallet`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Takes a private key and keeps it with the signer
         *
         * @tags Wallet
         * @name WalletImportWalletCreate
         * @request POST:/api/wallet/import-wallet
         * @secure
         */
        walletImportWalletCreate: (data, params = {}) => this.request({
            path: `/api/wallet/import-wallet`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Hands back a wallet's private key, to whoever owns it
         *
         * @tags Wallet
         * @name WalletExportWalletCreate
         * @request POST:/api/wallet/export-wallet
         * @secure
         */
        walletExportWalletCreate: (data, params = {}) => this.request({
            path: `/api/wallet/export-wallet`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Buys or sells from a wallet whose key we keep
         *
         * @tags Wallet
         * @name WalletSwapCreate
         * @request POST:/api/wallet/swap
         * @secure
         */
        walletSwapCreate: (data, params = {}) => this.request({
            path: `/api/wallet/swap`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description The device's wallets on a chain, with holdings and prices
         *
         * @tags Wallet
         * @name WalletEnrichWalletsCreate
         * @request POST:/api/wallet/enrich-wallets
         * @secure
         */
        walletEnrichWalletsCreate: (query, data, params = {}) => this.request({
            path: `/api/wallet/enrich-wallets`,
            method: 'POST',
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Puts wallets in this order, the rest after them
         *
         * @tags Wallet
         * @name WalletReorderCreate
         * @request POST:/api/wallet/reorder
         * @secure
         */
        walletReorderCreate: (data, params = {}) => this.request({
            path: `/api/wallet/reorder`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Removes a wallet
         *
         * @tags Wallet
         * @name WalletDelete
         * @request DELETE:/api/wallet/{id}
         * @secure
         */
        walletDelete: (id, params = {}) => this.request({
            path: `/api/wallet/${id}`,
            method: 'DELETE',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Changes a wallet's name, colour or star
         *
         * @tags Wallet
         * @name WalletEditWalletCreate
         * @request POST:/api/wallet/edit-wallet
         * @secure
         */
        walletEditWalletCreate: (data, params = {}) => this.request({
            path: `/api/wallet/edit-wallet`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Hides or shows a token, or adds one to the list
         *
         * @tags Wallet
         * @name WalletEditAssetCreate
         * @request POST:/api/wallet/edit-asset
         * @secure
         */
        walletEditAssetCreate: (data, params = {}) => this.request({
            path: `/api/wallet/edit-asset`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Reads a wallet's holdings now
         *
         * @tags Wallet
         * @name WalletRefreshBalanceCreate
         * @request POST:/api/wallet/refresh-balance
         * @secure
         */
        walletRefreshBalanceCreate: (data, params = {}) => this.request({
            path: `/api/wallet/refresh-balance`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
    };
    walletsTracker = {
        /**
         * @description The wallets the user tracks on a chain
         *
         * @tags Wallets Tracker
         * @name WalletsTrackerGetTrackingWalletsList
         * @request GET:/api/wallets-tracker/get-tracking-wallets
         * @secure
         */
        walletsTrackerGetTrackingWalletsList: (query, params = {}) => this.request({
            path: `/api/wallets-tracker/get-tracking-wallets`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Tracks wallets; ones already tracked are kept as they are
         *
         * @tags Wallets Tracker
         * @name WalletsTrackerImportTrackingWalletsCreate
         * @request POST:/api/wallets-tracker/import-tracking-wallets
         * @secure
         */
        walletsTrackerImportTrackingWalletsCreate: (data, params = {}) => this.request({
            path: `/api/wallets-tracker/import-tracking-wallets`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Changes a tracked wallet's name, tags or alerts
         *
         * @tags Wallets Tracker
         * @name WalletsTrackerEditTrackingWalletCreate
         * @request POST:/api/wallets-tracker/edit-tracking-wallet
         * @secure
         */
        walletsTrackerEditTrackingWalletCreate: (data, params = {}) => this.request({
            path: `/api/wallets-tracker/edit-tracking-wallet`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Stops tracking a wallet
         *
         * @tags Wallets Tracker
         * @name WalletsTrackerDeleteTrackingWalletCreate
         * @request POST:/api/wallets-tracker/delete-tracking-wallet
         * @secure
         */
        walletsTrackerDeleteTrackingWalletCreate: (data, params = {}) => this.request({
            path: `/api/wallets-tracker/delete-tracking-wallet`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description The tracked wallets' latest trades
         *
         * @tags Wallets Tracker
         * @name WalletsTrackerGetAlertsList
         * @request GET:/api/wallets-tracker/get-alerts
         * @secure
         */
        walletsTrackerGetAlertsList: (query, params = {}) => this.request({
            path: `/api/wallets-tracker/get-alerts`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    basic = {
        /**
         * @description Which of the two modes this account trades in
         *
         * @tags Basic
         * @name BasicModeList
         * @request GET:/api/basic/mode
         * @secure
         */
        basicModeList: (params = {}) => this.request({
            path: `/api/basic/mode`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Switch between the simple and the self-custody mode
         *
         * @tags Basic
         * @name BasicModeCreate
         * @request POST:/api/basic/mode
         * @secure
         */
        basicModeCreate: (data, params = {}) => this.request({
            path: `/api/basic/mode`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description What this account can spend right now
         *
         * @tags Basic
         * @name BasicBalanceList
         * @request GET:/api/basic/balance
         * @secure
         */
        basicBalanceList: (params = {}) => this.request({
            path: `/api/basic/balance`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Where this account funds its balance
         *
         * @tags Basic
         * @name BasicDepositAddressesList
         * @request GET:/api/basic/deposit-addresses
         * @secure
         */
        basicDepositAddressesList: (params = {}) => this.request({
            path: `/api/basic/deposit-addresses`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description What this account holds, valued at the stored prices
         *
         * @tags Basic
         * @name BasicPositionsList
         * @request GET:/api/basic/positions
         * @secure
         */
        basicPositionsList: (params = {}) => this.request({
            path: `/api/basic/positions`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Buy a token out of the balance
         *
         * @tags Basic
         * @name BasicBuyCreate
         * @request POST:/api/basic/buy
         * @secure
         */
        basicBuyCreate: (data, params = {}) => this.request({
            path: `/api/basic/buy`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description What selling a share of a position would return
         *
         * @tags Basic
         * @name BasicSellQuoteCreate
         * @request POST:/api/basic/sell/quote
         * @secure
         */
        basicSellQuoteCreate: (data, params = {}) => this.request({
            path: `/api/basic/sell/quote`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Sell a share of a position
         *
         * @tags Basic
         * @name BasicSellCreate
         * @request POST:/api/basic/sell
         * @secure
         */
        basicSellCreate: (data, params = {}) => this.request({
            path: `/api/basic/sell`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Send the balance out of our custody
         *
         * @tags Basic
         * @name BasicWithdrawCreate
         * @request POST:/api/basic/withdraw
         * @secure
         */
        basicWithdrawCreate: (data, params = {}) => this.request({
            path: `/api/basic/withdraw`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
    };
    access = {
        /**
         * @description Whether this account may use the terminal yet
         *
         * @tags Access
         * @name AccessList
         * @request GET:/api/access/
         * @secure
         */
        accessList: (params = {}) => this.request({
            path: `/api/access/`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    services = {
        /**
         * No description
         *
         * @tags Services
         * @name ServicesGasPricesList
         * @request GET:/api/services/gas-prices
         * @secure
         */
        servicesGasPricesList: (params = {}) => this.request({
            path: `/api/services/gas-prices`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Services
         * @name ServicesQuoteCreate
         * @request POST:/api/services/quote
         * @secure
         */
        servicesQuoteCreate: (data, params = {}) => this.request({
            path: `/api/services/quote`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Services
         * @name ServicesGetSnipingSignaturesList
         * @request GET:/api/services/get-sniping-signatures
         * @secure
         */
        servicesGetSnipingSignaturesList: (params = {}) => this.request({
            path: `/api/services/get-sniping-signatures`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Services
         * @name ServicesGetNativePricesList
         * @request GET:/api/services/get-native-prices
         * @secure
         */
        servicesGetNativePricesList: (params = {}) => this.request({
            path: `/api/services/get-native-prices`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Services
         * @name ServicesGetLargestPoolList
         * @request GET:/api/services/get-largest-pool
         * @secure
         */
        servicesGetLargestPoolList: (query, params = {}) => this.request({
            path: `/api/services/get-largest-pool`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Check if a token is safe to buy premium subscription
         *
         * @tags Services
         * @name ServicesTokenSafetyCheckList
         * @request GET:/api/services/token/safety-check
         * @secure
         */
        servicesTokenSafetyCheckList: (query, params = {}) => this.request({
            path: `/api/services/token/safety-check`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Check if a token is safe to buy premium subscription
         *
         * @tags Services
         * @name ServicesPreviewEmojiCreate
         * @request POST:/api/services/preview-emoji
         * @secure
         */
        servicesPreviewEmojiCreate: (data, params = {}) => this.request({
            path: `/api/services/preview-emoji`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Upload Temporary Images to S3
         *
         * @tags Services
         * @name ServicesUploadTempImageCreate
         * @request POST:/api/services/upload/temp-image
         * @secure
         */
        servicesUploadTempImageCreate: (data, params = {}) => this.request({
            path: `/api/services/upload/temp-image`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Load seed data for premium subscription & trending tokens
         *
         * @tags Services
         * @name ServicesSeedDataList
         * @request GET:/api/services/seed-data
         * @secure
         */
        servicesSeedDataList: (query, params = {}) => this.request({
            path: `/api/services/seed-data`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A token's price in dollars
         *
         * @tags Services
         * @name ServicesPriceList
         * @request GET:/api/services/price
         * @secure
         */
        servicesPriceList: (query, params = {}) => this.request({
            path: `/api/services/price`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A token, with its premium
         *
         * @tags Services
         * @name ServicesGetTokenMetaList
         * @request GET:/api/services/get-token-meta
         * @secure
         */
        servicesGetTokenMetaList: (query, params = {}) => this.request({
            path: `/api/services/get-token-meta`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description The currencies a new user's list starts with
         *
         * @tags Services
         * @name ServicesDefaultAssetsList
         * @request GET:/api/services/default-assets
         * @secure
         */
        servicesDefaultAssetsList: (query, params = {}) => this.request({
            path: `/api/services/default-assets`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A new user's trade presets on every chain
         *
         * @tags Services
         * @name ServicesDefaultTradeSettingsList
         * @request GET:/api/services/default-trade-settings
         * @secure
         */
        servicesDefaultTradeSettingsList: (params = {}) => this.request({
            path: `/api/services/default-trade-settings`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Native prices, priority fees and the Jito tip
         *
         * @tags Services
         * @name ServicesNetworkDataList
         * @request GET:/api/services/network-data
         * @secure
         */
        servicesNetworkDataList: (params = {}) => this.request({
            path: `/api/services/network-data`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description An EVM chain's suggested gas fees
         *
         * @tags Services
         * @name ServicesGasNetworkCongestionList
         * @request GET:/api/services/gas-network-congestion
         * @secure
         */
        servicesGasNetworkCongestionList: (query, params = {}) => this.request({
            path: `/api/services/gas-network-congestion`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description The fee proxy's swap fee and treasury
         *
         * @tags Services
         * @name ServicesFeeConfigList
         * @request GET:/api/services/fee-config
         * @secure
         */
        servicesFeeConfigList: (params = {}) => this.request({
            path: `/api/services/fee-config`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A pool's card, with its creator's record
         *
         * @tags Services
         * @name ServicesPairInfoList
         * @request GET:/api/services/pair-info
         * @secure
         */
        servicesPairInfoList: (query, params = {}) => this.request({
            path: `/api/services/pair-info`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A token's pools, most liquid first
         *
         * @tags Services
         * @name ServicesGetPoolsList
         * @request GET:/api/services/get-pools
         * @secure
         */
        servicesGetPoolsList: (query, params = {}) => this.request({
            path: `/api/services/get-pools`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Pools by name, symbol, token address or pool address
         *
         * @tags Services
         * @name ServicesSearchPairList
         * @request GET:/api/services/search-pair
         * @secure
         */
        servicesSearchPairList: (query, params = {}) => this.request({
            path: `/api/services/search-pair`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description New pools
         *
         * @tags Services
         * @name ServicesPoolsGetNewCreate
         * @request POST:/api/services/pools/get-new
         * @secure
         */
        servicesPoolsGetNewCreate: (data, params = {}) => this.request({
            path: `/api/services/pools/get-new`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Top gainer pools
         *
         * @tags Services
         * @name ServicesPoolsGetTopGainersCreate
         * @request POST:/api/services/pools/get-top-gainers
         * @secure
         */
        servicesPoolsGetTopGainersCreate: (data, params = {}) => this.request({
            path: `/api/services/pools/get-top-gainers`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Cooking pools
         *
         * @tags Services
         * @name ServicesPoolsGetCookingPoolsCreate
         * @request POST:/api/services/pools/get-cooking-pools
         * @secure
         */
        servicesPoolsGetCookingPoolsCreate: (data, params = {}) => this.request({
            path: `/api/services/pools/get-cooking-pools`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Pools still on a curve, closest to graduating first
         *
         * @tags Services
         * @name ServicesPoolsGetFinalStretchCreate
         * @request POST:/api/services/pools/get-final-stretch
         * @secure
         */
        servicesPoolsGetFinalStretchCreate: (data, params = {}) => this.request({
            path: `/api/services/pools/get-final-stretch`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Pools holding the most attention, ranked the chosen way
         *
         * @tags Services
         * @name ServicesPoolsGetTrendingCreate
         * @request POST:/api/services/pools/get-trending
         * @secure
         */
        servicesPoolsGetTrendingCreate: (data, params = {}) => this.request({
            path: `/api/services/pools/get-trending`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description The trending strip: five fields of a pool, not a card
         *
         * @tags Services
         * @name ServicesPoolsTickerCreate
         * @request POST:/api/services/pools/ticker
         * @secure
         */
        servicesPoolsTickerCreate: (data, params = {}) => this.request({
            path: `/api/services/pools/ticker`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description The ways the trending column can be ranked
         *
         * @tags Services
         * @name ServicesTrendingStrategiesList
         * @request GET:/api/services/pools/trending-strategies
         * @secure
         */
        servicesTrendingStrategiesList: (params = {}) => this.request({
            path: `/api/services/pools/trending-strategies`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Recently graduated pools
         *
         * @tags Services
         * @name ServicesPoolsGetGraduatedPoolsCreate
         * @request POST:/api/services/pools/get-graduated-pools
         * @secure
         */
        servicesPoolsGetGraduatedPoolsCreate: (data, params = {}) => this.request({
            path: `/api/services/pools/get-graduated-pools`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description A creator's pools, newest first
         *
         * @tags Services
         * @name ServicesPoolGetByCreatorCreate
         * @request POST:/api/services/pool/get-by-creator
         * @secure
         */
        servicesPoolGetByCreatorCreate: (data, params = {}) => this.request({
            path: `/api/services/pool/get-by-creator`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description How many pools a creator launched, and how many graduated
         *
         * @tags Services
         * @name ServicesPoolGetByCreatorOverviewCreate
         * @request POST:/api/services/pool/get-by-creator-overview
         * @secure
         */
        servicesPoolGetByCreatorOverviewCreate: (data, params = {}) => this.request({
            path: `/api/services/pool/get-by-creator-overview`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description A pool's trades, or wallets' trades
         *
         * @tags Services
         * @name ServicesTxList
         * @request GET:/api/services/tx
         * @secure
         */
        servicesTxList: (query, params = {}) => this.request({
            path: `/api/services/tx`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A wallet's standing across every token it has touched
         *
         * @tags Services
         * @name ServicesWalletProfileList
         * @request GET:/api/services/wallet-profile
         * @secure
         */
        servicesWalletProfileList: (query, params = {}) => this.request({
            path: `/api/services/wallet-profile`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description The money one wallet has moved, newest first
         *
         * @tags Services
         * @name ServicesWalletTransfersList
         * @request GET:/api/services/wallet-transfers
         * @secure
         */
        servicesWalletTransfersList: (query, params = {}) => this.request({
            path: `/api/services/wallet-transfers`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description When one wallet makes its money, by the hour of its own week
         *
         * @tags Services
         * @name ServicesWalletDegenHoursList
         * @request GET:/api/services/wallet-degen-hours
         * @secure
         */
        servicesWalletDegenHoursList: (query, params = {}) => this.request({
            path: `/api/services/wallet-degen-hours`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description The trades a pool's chart marks
         *
         * @tags Services
         * @name ServicesTxMakerList
         * @request GET:/api/services/tx/maker
         * @secure
         */
        servicesTxMakerList: (query, params = {}) => this.request({
            path: `/api/services/tx/maker`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A wallet's average buy and sell prices in a pool
         *
         * @tags Services
         * @name ServicesTxWalletPairAvgPricesList
         * @request GET:/api/services/tx/wallet-pair-avg-prices
         * @secure
         */
        servicesTxWalletPairAvgPricesList: (query, params = {}) => this.request({
            path: `/api/services/tx/wallet-pair-avg-prices`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description The wallets that made the most on a pool's token
         *
         * @tags Services
         * @name ServicesMakerTopTradersList
         * @request GET:/api/services/maker/top-traders
         * @secure
         */
        servicesMakerTopTradersList: (query, params = {}) => this.request({
            path: `/api/services/maker/top-traders`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description A pool's largest holders
         *
         * @tags Services
         * @name ServicesMakerHoldersList
         * @request GET:/api/services/maker/holders
         * @secure
         */
        servicesMakerHoldersList: (query, params = {}) => this.request({
            path: `/api/services/maker/holders`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description How a pool's holders and their shares have moved
         *
         * @tags Services
         * @name ServicesMakerHoldersChartList
         * @request GET:/api/services/maker/holders-chart
         * @secure
         */
        servicesMakerHoldersChartList: (query, params = {}) => this.request({
            path: `/api/services/maker/holders-chart`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description One wallet's figures in a pool's token
         *
         * @tags Services
         * @name ServicesMakerGetByAddressCreate
         * @request POST:/api/services/maker/get-by-address
         * @secure
         */
        servicesMakerGetByAddressCreate: (data, params = {}) => this.request({
            path: `/api/services/maker/get-by-address`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
    };
    leaderboard = {
        /**
         * @description This endpoint allows to get all leaderboard users.
         *
         * @tags Leaderboard
         * @name LeaderboardList
         * @request GET:/api/leaderboard/
         * @secure
         */
        leaderboardList: (query, params = {}) => this.request({
            path: `/api/leaderboard/`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    internal = {
        /**
         * @description Upload token logo and return token meta
         *
         * @tags Internal
         * @name InternalTokenLogoCreate
         * @request POST:/api/internal/token-logo
         * @secure
         */
        internalTokenLogoCreate: (query, params = {}) => this.request({
            path: `/api/internal/token-logo`,
            method: 'POST',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    premium = {
        /**
         * @description Recent premium and booster purchases, newest first
         *
         * @tags Premium
         * @name PremiumPurchasesFeedList
         * @request GET:/api/premium/purchases-feed
         * @secure
         */
        premiumPurchasesFeedList: (query, params = {}) => this.request({
            path: `/api/premium/purchases-feed`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    chartPrice = {
        /**
         * @description A pool's price and market-cap candles
         *
         * @tags ChartPrice
         * @name ChartPriceList
         * @request GET:/api/chart-price/
         * @secure
         */
        chartPriceList: (query, params = {}) => this.request({
            path: `/api/chart-price/`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    call = {
        /**
         * @description Make a call
         *
         * @tags Call
         * @name CallCreate
         * @request POST:/api/call/
         * @secure
         */
        callCreate: (data, params = {}) => this.request({
            path: `/api/call/`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Find a call inside a group
         *
         * @tags Call
         * @name CallList
         * @request GET:/api/call/
         * @secure
         */
        callList: (query, params = {}) => this.request({
            path: `/api/call/`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description Record a call and answer immediately
         *
         * @tags Call
         * @name CallAcceptCreate
         * @request POST:/api/call/accept
         * @secure
         */
        callAcceptCreate: (data, params = {}) => this.request({
            path: `/api/call/accept`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Resolve the pool behind an accepted call
         *
         * @tags Call
         * @name CallCompleteCreate
         * @request POST:/api/call/complete
         * @secure
         */
        callCompleteCreate: (data, params = {}) => this.request({
            path: `/api/call/complete`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description Find a call inside a group
         *
         * @tags Call
         * @name CallGroupCallList
         * @request GET:/api/call/group-call
         * @secure
         */
        callGroupCallList: (query, params = {}) => this.request({
            path: `/api/call/group-call`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
    };
    group = {
        /**
         * @description Update group settings
         *
         * @tags Group
         * @name GroupCreate
         * @request POST:/api/group/
         * @secure
         */
        groupCreate: (data, params = {}) => this.request({
            path: `/api/group/`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * @description What a group owner and a referrer earn, as configured
         *
         * @tags Group
         * @name GroupEarningsRatesList
         * @request GET:/api/group/earnings-rates
         * @secure
         */
        groupEarningsRatesList: (params = {}) => this.request({
            path: `/api/group/earnings-rates`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        }),
        /**
         * @description How a cabal is doing, and what it has earned its owner
         *
         * @tags Group
         * @name GroupStatsDetail
         * @request GET:/api/group/{groupId}/stats
         * @secure
         */
        groupStatsDetail: ({ groupId, ...query }, params = {}) => this.request({
            path: `/api/group/${groupId}/stats`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        }),
    };
}
//# sourceMappingURL=generatedApi.js.map